import { getFunctions, httpsCallable } from 'firebase/functions'

// Događaj s pozivnice, onako kako ga vidi gost. Sva polja mogu izostati: par
// pozivnicu ispunjava kroz više sjedanja, a link dijeli prije nego je gotova.
export interface IRsvpDogadjaj {
	naziv: string | null
	mjesto: string | null
	adresa: string | null
	vrijeme: string | null
}

export interface IRsvpPozivnica {
	obred: IRsvpDogadjaj | null
	domjenak: IRsvpDogadjaj | null
	poruka: string | null
	rokPotvrde: string | null
}

export interface IRsvpVjencanje {
	brideName: string
	groomName: string
	weddingDate: string
	language: string
	// Izostaje dok par ne upiše nijedno polje.
	pozivnica?: IRsvpPozivnica | null
}

export type RsvpIshod =
	| 'potvrdeno' | 'vise-podudaranja' | 'nepoznato' | 'prag' | 'prepuno'

export interface IRsvpRezultat {
	ishod: RsvpIshod
	// Samo uz 'vise-podudaranja': koliko je istoimenih gostiju nađeno.
	broj?: number
	// Samo uz 'potvrdeno': koliko je članova pratnje potvrđeno (upisano ili već
	// jednoznačno bilo na popisu), a koliko stvarno odbijeno — neispravno ime,
	// više istoimenih na popisu, prepun popis ili prag. Član kojeg je par već
	// jednoznačno unio NIJE odbijenica: stranica od svake odbijenice radi
	// "javite se mladencima".
	pratnjaUpisana?: number
	pratnjaOdbijena?: number
}

export const rsvpLookupEndpoint = async (token: string): Promise<IRsvpVjencanje> => {
	const callable = httpsCallable(getFunctions(), 'rsvpLookup')
	const result = await callable({ token })
	return result.data as IRsvpVjencanje
}

export const rsvpSubmitEndpoint = async (input: {
	token: string
	ime: string
	prezime: string
	status: 'confirmed' | 'declined'
	dopustiDopunu?: boolean
	pratnja?: { ime: string, prezime: string }[]
}): Promise<IRsvpRezultat> => {
	const callable = httpsCallable(getFunctions(), 'rsvpSubmit')
	const result = await callable(input)
	return result.data as IRsvpRezultat
}

export const rsvpApproveGuestEndpoint = async (
	plannerId: string,
	guestId: string
): Promise<void> => {
	const callable = httpsCallable(getFunctions(), 'rsvpApproveGuest')
	await callable({ plannerId, guestId })
}

// Vraća link koji par dijeli s uzvanicima. Poziv je idempotentan na
// poslužitelju - token se mintuje samo prvi put, svaki sljedeći poziv vraća
// isti, pa link već otisnut na pozivnici ostaje valjan.
export const rsvpEnsureTokenEndpoint = async (plannerId: string): Promise<string> => {
	const callable = httpsCallable(getFunctions(), 'rsvpEnsureToken')
	const result = await callable({ plannerId })
	return (result.data as { rsvpToken: string }).rsvpToken
}
